import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { shiftDatePeriod } from '@/lib/date-period.mjs';

// Shared visual/behavior contract for read-only period filters across the POS.
export default function DatePeriodNavigation({ start, end, onChange, children, label = 'Periode tanggal', testId = 'date-period', className = '', disabled = false }) {
  const [phone, setPhone] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.('(max-width: 639px)').matches);
  useEffect(() => {
    const media = window.matchMedia?.('(max-width: 639px)');
    if (!media) return;
    const change = event => setPhone(event.matches);
    media.addEventListener('change', change);
    return () => media.removeEventListener('change', change);
  }, []);
  // Keep the existing phone controls and layout; arrows are desktop/tablet only.
  if (phone) return children;
  const previous = shiftDatePeriod(start, end, -1), next = shiftDatePeriod(start, end, 1);
  const canMove = !disabled && previous && next;
  const title = canMove ? 'Geser satu hari, satu bulan penuh, atau sepanjang rentang terpilih' : 'Pilih tanggal atau rentang terlebih dahulu';
  const buttonClass = 'h-9 w-9 shrink-0 border-ui-line bg-ui-card p-0 sm:h-10 sm:w-10';
  return <div role="group" aria-label={label} data-testid={testId} className={`flex max-w-full min-w-0 items-center gap-1 ${className}`}>
    <Button type="button" variant="outline" aria-label={`${label}: sebelumnya`} title={title} data-testid={`${testId}-prev`} disabled={!canMove} className={buttonClass} onClick={() => onChange(previous)}><ChevronLeft className="h-4 w-4" /></Button>
    <div className="flex min-w-0 flex-1 items-center gap-1 [&>button]:min-w-0 [&>button]:flex-1 [&>select]:min-w-0 [&>select]:max-w-full">{children}</div>
    <Button type="button" variant="outline" aria-label={`${label}: berikutnya`} title={title} data-testid={`${testId}-next`} disabled={!canMove} className={buttonClass} onClick={() => onChange(next)}><ChevronRight className="h-4 w-4" /></Button>
  </div>;
}
